import { Component, ViewContainerRef } from '@angular/core';
import { Coupon, ProductSelectList } from '../../../models/coupons/coupon-model'
import { CouponsService } from '../../../services/coupons/coupons.service';
import { DiscountType } from '../../../models/coupons/discount-type-model';
import { DiscountTypeService } from '../../../services/coupons/discount-type.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Category } from '../../../models/category/category.model';
import { Product } from '../../../models/products/product.model';
import { CategoryService } from '../../../services/category/category.service';
import { ProductService } from '../../../services/product/product.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { EnumDropDown } from '../../../models/shared/enum-dropdown'
import { CustomerService } from '../../../services/customer/customer.service';
import { Customer } from '../../../models/customer/customer-model';
import { RolePermissionService } from '../../../services/role/role-permission.service';
import { forEach } from '@angular/router/src/utils/collection';
@Component({
  selector: 'app-edit-coupon',
  templateUrl: './edit-coupon.component.html',
  styleUrls: ['./edit-coupon.component.scss']
})
/** edit-coupon component*/
export class EditCouponComponent {
  public couponModel = new Coupon();
  couponID: string;
  errorMessage: any;
  public plateFormsList: EnumDropDown[];
  vendorList: Customer[];
  validate: boolean;
  categories: Category[];
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
  products: Product[];
  productlist: Product[];
  product = new Product();
  productIds = new ProductSelectList();
  showProductList: boolean = false;
  showCategoryList: boolean = false;
  showCouponMsg: boolean = false;
  couponType: string;
  public showSuggestions: boolean = false;
  public showProduct: boolean = false;
  isUnique: boolean = true;
  discountTypeList: DiscountType[];
  public startDateElement: any;
  public endDateElement: any;
  public showPercent: boolean = false;
  public showFixed: boolean = false;
  public productsDropdownSettings = {
    singleSelection: false,
    idField: 'productID',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public categoriesDropdownSettings = {
    singleSelection: false,
    idField: 'categoryID',
    textField: 'categoryName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  /** edit-coupon ctor */
  constructor(private readonly couponService: CouponsService, private readonly activatedRoute: ActivatedRoute,
    private readonly discountTypeService: DiscountTypeService, private readonly categoryService: CategoryService,
    private readonly productService: ProductService,
    private readonly customerService: CustomerService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.products = [];
    this.rolePermissionService.GetRolePermissions("coupon").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.activatedRoute.params.subscribe((params: Params) => {
              this.couponID = params['id'];
              this.toastr.setRootViewContainerRef(vcr);
            });
            this.couponType = "";
            this.showCategoryList = false;
            this.showProductList = false;
            
            this.getDiscountTypes();
           // this.getProducts();
           // this.getCategories();
            this.GetDomainTypes();
            this.getVendorsList();
            this.getdiscountType(this.couponID);
            this.validate = true;
            this.couponModel.plateFormID = null;
          }
          else {
            this.router.navigate(["/coupons"]);
          }
        }
        else {
          this.router.navigate(["/coupons"]);
        }
      }
    )
    this.minDate = new Date();
    this.maxDate = new Date();
    this.endMaxDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
  }

  onSubmit() {

    this.validate = false;
    this.couponService.isUniqueCode(this.couponModel.couponCode, this.couponModel.couponID).subscribe(
      data => {
        if (data == true) {
          this.isUnique = true;
          if (this.couponType == "") {
            this.showCouponMsg = true;
          }
          if (this.showPercent == true) {
            if (this.couponModel.couponAmount > 100) {
              this.couponModel.couponAmount = 100;
            }
          }
          if (this.couponType == "0") {
            this.couponModel.productIds = [];
            this.couponModel.categories = [];
            this.couponModel.products = [];
          }
          if (this.couponModel.productIds.length == 0 && this.couponModel.categoryIds.length == 0 && this.couponModel.products.length == 0 && this.couponType != "0") {
            this.showCouponMsg = true;
            return;
          }
          else {
            this.showCouponMsg = false;
          }
          if (this.couponType == "1") {
            this.couponModel.productIds = [];
            this.couponModel.products = [];
          }
          if (this.couponType == "2") {
            this.couponModel.categoryIds = [];
            this.couponModel.categories = [];
          }
          

          this.couponService.updateCoupon(this.couponModel).subscribe(result => {
            if (result) {
              this.toastr.success('Coupons has been Updated. ', 'Success');
              setTimeout(() => {
                this.router.navigate(["/coupons"]);
              }, 1000);
            }
            else {
              this.toastr.error('Error occurred. Please try again', 'Success');
            }
          });
        }
        else {
          this.isUnique = false;
          this.validate = true;
          window.scroll(0, 0);
        }
      });
  }
  formatDate(date: string): string {
    let newDate: any = date.split('-');
    let days: number = parseInt(newDate[2]);
    let months: number = parseInt(newDate[1]);
    let year: number = parseInt(newDate[0]);
    return months + "/" + days + "/" + year;
  }

  GetDomainTypes() {
    this.couponService.GetDomainTypes().subscribe(
      data => {
        this.plateFormsList = data;
      }
    )
  }

  getVendorsList() {
    this.customerService.getActiveVendors().subscribe(
      data => {
        this.vendorList = data;
      }
    )
  }

  getdiscountType(discountTypeID: string) {
    this.couponService.getCoupon(discountTypeID).subscribe(
      data => {
        this.couponModel = data;
        this.products = [];
        let discountNatue = this.discountTypeList.filter(x => x.discountTypeID == this.couponModel.discountTypeId)[0];
        if (discountNatue.discountNatureType == 1) {
          this.showPercent = true;
        }
        if (discountNatue.discountNatureType == 2) {
          this.showFixed = true;
        }
        if (this.couponModel.productIds.length > 0) {
          this.showProductList = true;
          this.couponType = "2";
          for (var i = 0; i < this.couponModel.productIds.length; i++) {
            this.product = new Product();
            this.product.name = this.couponModel.productIds[i].name;
            this.product.productID = this.couponModel.productIds[i].productID;
            this.products.push(this.product);
            this.showProduct = true;
          }
        }
        if (this.couponModel.categoryIds.length > 0) {
          this.getCategoriesByVendorId(this.couponModel.vendorId);
          this.showCategoryList = true;
          this.couponType = "1";
        }
        if (this.couponModel.categoryIds.length == 0 && this.couponModel.productIds.length == 0) {
          this.couponType = "0";
        }
        //let start = new Date(this.couponModel.startDate).toString();
        //let end = new Date(this.couponModel.endDate).toString();
        //var start = new Date(this.couponModel.startDate);
        // var end = new Date(this.couponModel.endDate);
        this.couponModel.startDate = this.formatDate(this.couponModel.startDate);
        this.couponModel.endDate = this.formatDate(this.couponModel.endDate);
      }
    )
  }
  isActiveCheckbox(e) {
    this.couponModel.isActive = e.target.checked;
  }
  selectStartDate(e) {
    if (e != null) {
      this.couponModel.startDate = e;
      //this.minDate = e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
      //this.endMaxDate.setDate(this.maxDate.getDate() + 1);
    }
  }
  selectEndDate(e) {
    if (e != null) {
      this.couponModel.endDate = e;
    }
  }
  getDiscountTypes() {
    this.discountTypeService.getActiveDiscountTypes().subscribe(
      data => {
        this.discountTypeList = data;
      }
    )
  }

  getProducts() {
    this.productService.GetProducts().subscribe(
      data => {
        this.products = data;
      }
    )
  }

  getCategories() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.categories = data;
      }
    )
  }
  onSearch(searchText: string) {
    var length = 0;
    try {
      length = searchText.length;
    } catch (e) {
      this.showSuggestions = false;
      return;
    }
    if (length > 0) {
      this.productService.ProductSuggestionsByVendor(searchText, this.couponModel.vendorId).subscribe(
        data => {
          this.productlist = data;
          if (this.productlist.length > 0) {
            this.showSuggestions = true;
          }
        });
    }
    else {
      this.productlist = [];
      this.showSuggestions = false;
    }
  }
  SelectProduct(product: Product) {
    this.product = product;
    if (!this.products.some((item) => item.productID == this.product.productID)) {
      this.products.push(this.product);
      this.showProduct = true;
      this.productIds = new ProductSelectList();
      this.productIds.productID = this.product.productID;
      this.productIds.name = this.product.name;
      this.couponModel.productIds.push(this.productIds);
    }
    else {
      this.toastr.error('This item is already Exist', 'Fail!');
    }
    this.showSuggestions = false;
  }
  cancelProduct(index) {
    this.products.splice(index, 1);
    if (this.products.length == 0) {
      this.showProduct = false;
    }
    this.couponModel.productIds.splice(index, 1);
  }
  showCouponType() {
    if (this.couponType == "") {
      this.showProductList = false;
      this.showCategoryList = false;
      this.showCouponMsg = false;
    }
    if (this.couponType == "1") {
      this.showProductList = false;
      this.showCategoryList = true;
      this.showCouponMsg = false;
      this.getCategoriesByVendorId(this.couponModel.vendorId);

    }
    if (this.couponType == "2") {
      this.showCategoryList = false;
      this.showProductList = true;
      this.showCouponMsg = false;
    }

    if (this.couponType == "0") {
      this.showCategoryList = false;
      this.showProductList = false;
      this.showCouponMsg = false;
    }
  }
  getCategoriesByVendorId(id: number) {
    if (id == null) {
      id = 0;
      this.couponModel.vendorId = 0;
    }
    this.categoryService.GetCategoryListByVendor(id).subscribe(
      data => {
        this.categories = data;
      }
    )
  }
  keyPress(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
  ExistErrorHide() {
    this.isUnique = true;
  }
  ShowDiscountTypeAmount() {
    let discountNatue = this.discountTypeList.filter(x => x.discountTypeID == this.couponModel.discountTypeId)[0];
    
    if (discountNatue.discountNatureType == 1) {
      this.showPercent = true;
      this.showFixed = false;
    }
    if (discountNatue.discountNatureType == 2) {
      this.showFixed = true;
      this.showPercent = false;
    }
  }
  checkPercent(event: any) {
    if (this.couponModel.couponAmount > 100) {
      this.couponModel.couponAmount = 100;
    }
    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
      this.couponModel.couponAmount = null;
      return false;
    }
    return true;

  }
}



// WEBPACK FOOTER //
// ./src/app/coupons/coupons/edit-coupon/edit-coupon.component.ts